import React, { FC } from 'react';
import { Container, Row } from 'reactstrap';
import styles from './DownloadStarted.module.scss';
import classnames from 'classnames';
import { useTranslations } from 'next-intl';

//Import components
import SingleItem from '@/components/Grids/SingleItem/SingleItem';
import PopUpTextLink from '@/components/PopUpTextLink/PopUpTextLink';

// Import lib files
import { sectionHeadings } from '@/libs/interfaceProps/sectionHeadings';
import { fulfillmentPageCompsProps } from '@/libs/interfaceProps/fulfillmentPageCompsProps';
const singleSectionHeading: sectionHeadings = {
  sectionHeadingTitle: ''
};
const DownloadStarted: FC<fulfillmentPageCompsProps> = ({
  params,
  queryParams
}) => {
  const t = useTranslations('Fulfillment');
  return <>
   <Container className={classnames(styles['download-banner-comp'], 'banners download-banner')} data-bdd={'download-started-banner'} data-sentry-element="Container" data-sentry-source-file="DownloadStarted.tsx">
    <h1 className={classnames(styles['download-banner-heading'], 'section-heading')} data-bdd={'section-heading_download-started'}>
     {t('DownloadStarted')}
    </h1>

    <SingleItem {...singleSectionHeading} params={params} queryParams={queryParams} data-sentry-element="SingleItem" data-sentry-source-file="DownloadStarted.tsx" />

    <Row className={styles['view-asset']} data-sentry-element="Row" data-sentry-source-file="DownloadStarted.tsx">
     <PopUpTextLink data-sentry-element="PopUpTextLink" data-sentry-source-file="DownloadStarted.tsx" />
    </Row>
   </Container>
  </>;
};
export default DownloadStarted;